import { render } from "./index.vue?vue&type=template&id=bd63741a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bd63741a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd63741a"],['__file',"src/vab/layouts/VabLayoutColumn/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd63741a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd63741a', __exports__)) {
    console.log('reload')
    api.reload('bd63741a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=bd63741a&scoped=true", () => {
    console.log('re-render')
    api.rerender('bd63741a', render)
  })

}


export default __exports__